import { render, staticRenderFns } from "./applications.vue?vue&type=template&id=5cdaa896&scoped=true&"
import script from "./applications.vue?vue&type=script&lang=js&"
export * from "./applications.vue?vue&type=script&lang=js&"
import style0 from "./applications.vue?vue&type=style&index=0&id=5cdaa896&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdaa896",
  null
  
)

export default component.exports